import { render, staticRenderFns } from "./form_add_happiness_tips_component.vue?vue&type=template&id=024cedc1"
import script from "./form_add_happiness_tips_component.vue?vue&type=script&lang=js"
export * from "./form_add_happiness_tips_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports